// import React, { useEffect, useState } from "react";
// import logo from "../images/logo.png";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import { FiMenu } from "react-icons/fi";
// import { motion, AnimatePresence } from "framer-motion";
// import ResBar from "./ResBar";
// import { VscTools } from "react-icons/vsc";
// import Login from "./login_review";

// function Navbar() {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [login, setLogin] = useState(false);
//   const [show, setShow] = useState(false);
//   const [openDropdown, setOpenDropdown] = useState(false);
//   useEffect(() => {
//     setOpenDropdown(false);
//   }, [location]);
//   // Example product data
//   const products = [
//     {
//       id: 1,
//       name: " MCT MCRS",
//       desc: " Enterprise Cyber Governance, Risk & Compliance Platform.",
//       route: "/mct_grc",
//     },
//     {
//       id: 2,
//       name: "Inventory Management",
//       desc: "Master Your Stock: Know What You Have and Where It Is.",
//       route: "/mct_inventory_management",
//     },
//     {
//       id: 3,
//       name: "Document Management System",
//       desc: "Web-based Document Management System.",
//       route: "/mct_dms",
//     },
//     {
//       id: 4,
//       name: "Help Desk",
//       desc: " Emerges as a cutting-edge web solution.",
//       route: "/mct_helpdesk",
//     },
//   ];

//   return (
//     <>
//       <ResBar show={show} setShow={setShow} />
//       <div className="absolute max-[780px]:px-10 flex px-20 pt-4 justify-between w-full z-50">
//         {/* Logo */}
//         <img
//           onClick={() => navigate("/")}
//           src={logo}
//           className="cursor-pointer w-40 h-10 max-[650px]:w-32 max-[650px]:h-8"
//           alt="logo_img"
//         />

//         {/* Main Nav */}
//         <div className="flex items-center max-[740px]:hidden gap-6 text-sm rounded-full bg-opacity-65 text-white bg-black py-3 px-5 relative">
//           <NavLink to="/">Home</NavLink>
//           <NavLink to="/about">About Us</NavLink>
//           <NavLink to="/productpage">Products</NavLink>
//           <NavLink to="/productpage">Solutions</NavLink>
//           <NavLink to="/services">Services</NavLink>
//           <NavLink to="/blog">Blog</NavLink>
//           <NavLink to="/privacy_policy">Privacy Policy</NavLink>
//           <NavLink to="/faq_?">FAQ</NavLink>
//           <NavLink to="/contactpage">Contact Us</NavLink>
//           {/* <NavLink to="/admin_login">Reviews</NavLink> */}
//           {/* <p onClick={() => setLogin(true)} className="cursor-pointer py-1 px-2 rounded-full hover:bg-cyan-600">Reviews</p> */}

//           {/* Sas Products Dropdown */}
//           <div className="relative">
//             <button
//               onClick={() => setOpenDropdown((prev) => !prev)}
//               className="px-4 py-2 transition hover:bg-cyan-700 transition text-sm font-medium rounded-md text-white bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 transition-all"
//             >
//               Saas Products
//             </button>

//             {/* Dropdown */}
//             {openDropdown && (
//               <motion.div
//                 // initial={{ opacity: 0, scale: 0.95, y: -10 }}
//                 // animate={{ opacity: 1, scale: 1, y: 0 }}
//                 // exit={{ opacity: 0, scale: 0.95, y: -10 }}
//                 // transition={{ duration: 0.25 }}
//                 className="absolute top-12 right-0 bg-gradient bg-gradient-to-br from-cyan-950 to-gray-950 shadow-2xl rounded-2xl p-4 w-[650px] max-w-[95vw] grid grid-cols-2  gap-6 z-50"
//               >
//                 {products.map((product) => (
//                   <motion.div
//                     key={product.id}
//                     whileTap={{ scale: 0.98 }}
//                     className="rounded-xl p-5 flex flex-col justify-between"
//                   >
//                     <div>
//                       <div className="flex items-center gap-3">
//                         <VscTools className="text-white text-4xl shadow-md p-2 rounded-full border-gray-500 border" />
//                         <h4 className="font-semibold text-lg text-white">
//                           {product.name}
//                         </h4>
//                       </div>
//                       <p className="text-sm mt-1 text-gray-300">
//                         {product.desc}
//                       </p>
//                     </div>
//                     <p
//                       onClick={() => navigate(`${product.route}`)}
//                       className="text-sm mt-2 flex hover:gap-3 items-center gap-1 font-medium hover:text-cyan-400 cursor-pointer text-cyan-200 hover:text-cyan-400"
//                     >
//                       <span>TRY NOW</span>{" "}
//                       <span className="text-2xl mb-1">&rsaquo;</span>
//                     </p>
//                   </motion.div>
//                 ))}
//               </motion.div>
//             )}
//           </div>
//         </div>

//         {login && <Login onCancel={() => setLogin(false)} />}
//         {/* Mobile Menu */}
//         {!show && (
//           <FiMenu
//             onClick={() => setShow(true)}
//             className="text-white text-3xl hidden max-[740px]:block"
//           />
//         )}
//       </div>
//     </>
//   );
// }

// export default Navbar;

import React, { useEffect, useRef, useState } from "react";
import logo from "../images/logo.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import ResBar from "./ResBar";
import { VscTools } from "react-icons/vsc";
import Login from "./login_review";

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [login, setLogin] = useState(false);
  const [show, setShow] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Close dropdown on route change
  useEffect(() => {
    setOpenDropdown(false);
  }, [location]);

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const products = [
    {
      id: 1,
      name: "MCT MCRS",
      desc: "Enterprise Cyber Governance, Risk & Compliance Platform.",
      route: "/mct_grc",
    },
    {
      id: 2,
      name: "Inventory Management",
      desc: "Master Your Stock: Know What You Have and Where It Is.",
      route: "/mct_inventory_management",
    },
    {
      id: 3,
      name: "Document Management System",
      desc: "Web-based Document Management System.",
      route: "/mct_dms",
    },
    {
      id: 4,
      name: "Help Desk",
      desc: "Cutting-edge support solution.",
      route: "/mct_helpdesk",
    },
  ];

  return (
    <>
      <ResBar show={show} setShow={setShow} />

      {/* Navbar */}
      <div
        className={`fixed top-0 left-0 w-full z-50  border-b border-white/10 transition-all duration-300 ${
          scrolled
            ? "bg-[#fff]/2 backdrop-blur-md border-b"
            : "bg-transparent"
        }`}
      >
        <div className="flex justify-between items-center px-10 max-[780px]:px-8 py-5">
          
          {/* Logo */}
          <img
            onClick={() => navigate("/")}
            src={logo}
            className="cursor-pointer w-40 h-10 max-[650px]:w-32 max-[650px]:h-8"
            alt="logo_img"
          />

          {/* Desktop Nav */}
          <div className="flex items-center gap-6 text-md text-gray-300 max-[740px]:hidden">
            <NavLink to="/" className="hover:text-cyan-400 transition">
              Home
            </NavLink>

           

            <NavLink
              to="/productpage"
              className="hover:text-cyan-400 transition"
            >
              Products
            </NavLink>

            <NavLink
              to="/solutions"
              className="hover:text-cyan-400 transition"
            >
              Solutions
            </NavLink>

            <NavLink
              to="/services"
              className="hover:text-cyan-400 transition"
            >
              Services
            </NavLink>
            <NavLink
              to="/partners"
              className="hover:text-cyan-400 transition"
            >
              Partner & Ecosystem
            </NavLink>

            <NavLink to="/blog" className="hover:text-cyan-400 transition">
              Blog
            </NavLink>

            {/* SaaS Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setOpenDropdown(!openDropdown)}
                className="hover:text-cyan-400 transition"
              >
                SaaS Products
              </button>

              <AnimatePresence>
                {openDropdown && (
                  <motion.div
                    initial={{ opacity: 0, y: -15 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -15 }}
                    className="absolute top-12 right-0 w-[650px] max-w-[95vw] 
                    bg-[#061328] backdrop-blur-lg border border-white/10
                    rounded-2xl p-5 grid grid-cols-2 gap-4 shadow-2xl"
                  >
                    {products.map((product) => (
                      <div
                        key={product.id}
                        className="p-4 rounded-xl bg-white/5 hover:bg-white/10 transition"
                      >
                        <div className="flex gap-3 items-center">
                          <VscTools className="text-white text-3xl p-2 border border-gray-500 rounded-full" />
                          <h4 className="text-white font-semibold">
                            {product.name}
                          </h4>
                        </div>

                        <p className="text-gray-300 text-sm mt-2">
                          {product.desc}
                        </p>

                        <button
                          onClick={() => navigate(product.route)}
                          className="mt-3 text-cyan-400 text-sm"
                        >
                          TRY NOW →
                        </button>
                      </div>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
 <NavLink to="/about" className="hover:text-cyan-400 transition">
              About Us
            </NavLink>
            <NavLink
              to="/contactpage"
              className="bg-cyan-600 px-6 py-3 rounded-full hover:bg-cyan-700 transition"
            >
              Contact
            </NavLink>
          </div>

          {/* Login */}
          {login && <Login onCancel={() => setLogin(false)} />}

          {/* Mobile Menu */}
          {!show && (
            <FiMenu
              onClick={() => setShow(true)}
              className="text-white text-3xl hidden max-[740px]:block cursor-pointer"
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;